module.exports = __webpack_public_path__ + "./img/plane_animation.0fd3631a739312b43f2bd284d2c792d9.gif";


//////////////////
// WEBPACK FOOTER
// ./public/img/plane_animation.gif
// module id = ./public/img/plane_animation.gif
// module chunks = 0